const ARIA: Object = Object.freeze({
  hide: {
    'aria-hidden': true,
    role: 'presentation',
    tabIndex: -1,
  },
})

export default ARIA



// WEBPACK FOOTER //
// ./src/constants/aria.jsx